import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FollowersList } from "./FollowersList";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface FollowersModalProps {
  profileId: string;
  isOpen: boolean;
  onClose: () => void;
  initialTab?: "followers" | "following";
}

export const FollowersModal: React.FC<FollowersModalProps> = ({
  profileId,
  isOpen,
  onClose,
  initialTab = "followers"
}) => {
  const [activeTab, setActiveTab] = React.useState<"followers" | "following">(initialTab);

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center mb-2">Connections</DialogTitle>
        </DialogHeader>
        
        <Tabs 
          defaultValue={activeTab} 
          onValueChange={(value) => setActiveTab(value as "followers" | "following")}
          className="w-full"
        >
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="followers">Followers</TabsTrigger>
            <TabsTrigger value="following">Following</TabsTrigger>
          </TabsList>
          
          <TabsContent value="followers" className="mt-4">
            <FollowersList profileId={profileId} type="followers" />
          </TabsContent>
          
          <TabsContent value="following" className="mt-4">
            <FollowersList profileId={profileId} type="following" />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};
